/* eslint-disable */
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import contentfulClient from  './ui/contentfulClient'

import {
  configureStore,
  immutifyState,
  LocaleProvider,
  fetchMiddleware
} from '@telus/isomorphic-core'

import App from './ui/components/App'
import getUIRoutes from './ui/routes'
import { UI_BASENAME } from './config/constants'
import rootReducer from './ui/reducers'
import config from './config/ui'

const locale = {
  lang: window.__LOCALE__.lang || 'en',
  prov: window.__LOCALE__.prov || 'bc'
}

const rootEl = document.getElementById('app')

const initialState = window.__INITIAL_STATE__ ? immutifyState(window.__INITIAL_STATE__, ['contentful']) : {};

if (process.env.APP_ENV === 'development') {
  console.info('INIT STATE:', initialState)
}

/*
configureStore takes 3 args, the root reducer, init store state, and additional middlewares
by default, configureStore comes with redux-logger middleware. Here we
registering our fetchMiddleware
*/
const store = configureStore(rootReducer, initialState, [fetchMiddleware()])

let basename = `/${locale.lang}/${locale.prov}${UI_BASENAME}`

if (config.locale.removeLangAndProvFromUrl) {
  basename = `${UI_BASENAME}`
} else if (config.locale.removeProvFromUrl) {
  basename = `/${locale.lang}${UI_BASENAME}`
}

ReactDOM.hydrate(
  <BrowserRouter basename={basename}>
    <Provider store={store}>
      <LocaleProvider locale={locale}>
        <App>{getUIRoutes(contentfulClient, locale)}</App>
      </LocaleProvider>
    </Provider>
  </BrowserRouter>,
  rootEl
)
